import { CheckboxClass } from '../../components/boolean-fields/descope-checkbox/CheckboxClass';
import { refs } from './inputWrapper';

const vars = CheckboxClass.cssVarList;
const checkboxSize = '1.35em';

const checkbox = {
  [vars.hostWidth]: refs.width,
  [vars.hostDirection]: refs.direction,
  [vars.fontSize]: refs.fontSize,
  [vars.fontFamily]: refs.fontFamily,
  [vars.labelTextColor]: refs.labelTextColor,
  [vars.labelRequiredIndicator]: refs.requiredIndicator,
  [vars.labelFontWeight]: '400',
  [vars.labelLineHeight]: checkboxSize,
  [vars.labelSpacing]: '1em',
  [vars.errorMessageTextColor]: refs.errorMessageTextColor,
  [vars.inputOutlineWidth]: refs.outlineWidth,
  [vars.inputOutlineOffset]: refs.outlineOffset,
  [vars.inputOutlineColor]: refs.outlineColor,
  [vars.inputOutlineStyle]: refs.outlineStyle,
  [vars.inputBorderRadius]: refs.borderRadius,
  [vars.inputBorderColor]: refs.borderColor,
  [vars.inputBorderWidth]: refs.borderWidth,
  [vars.inputBorderStyle]: refs.borderStyle,
  [vars.inputBackgroundColor]: refs.backgroundColor,
  [vars.inputSize]: checkboxSize,
  [vars.inputValueTextColor]: refs.valueTextColor,

  // error message icon
  [vars.errorMessageIcon]: refs.errorMessageIcon,
  [vars.errorMessageIconSize]: refs.errorMessageIconSize,
  [vars.errorMessageIconPadding]: refs.errorMessageIconPadding,
  [vars.errorMessageIconRepeat]: refs.errorMessageIconRepeat,
  [vars.errorMessageIconPosition]: refs.errorMessageIconPosition,
  [vars.errorMessageFontSize]: refs.errorMessageFontSize,
};

export default checkbox;
export { vars };
